import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthVi = () => {
  useEffect(() => {
    document.documentElement.lang = "vi";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>
        Đồng ý về việc thu thập và sử dụng thông tin sức khỏe
      </PolicyTitle>

      <PolicyText>
        Khi tạo tài khoản, bạn có thể lựa chọn có đồng ý cho phép thu thập và sử
        dụng thông tin sức khỏe hay không. Việc đồng ý là tùy chọn và không bắt
        buộc để tạo tài khoản pregnancy&baby. Tuy nhiên, nếu không đồng ý, bạn
        có thể không sử dụng được các tính năng cần xử lý thông tin sức khỏe.
      </PolicyText>

      <PolicySectionTitle>1. Mục đích thu thập và sử dụng</PolicySectionTitle>
      <PolicyHyphenList>
        <li>
          Cung cấp các tính năng ghi chép và quản lý liên quan đến chuẩn bị mang
          thai, điều trị hiếm muộn, thai kỳ và chăm sóc trẻ
        </li>
        <li>
          Cung cấp các tính năng được cá nhân hóa mà bạn lựa chọn, bao gồm dự
          đoán chu kỳ kinh và ngày rụng trứng, tính tuổi thai, phân tích kết quả
          xét nghiệm, phân tích sự phát triển của thai nhi và đánh giá tăng
          trưởng, phát triển của trẻ
        </li>
        <li>
          Cung cấp lời nhắc và thông tin liên quan đến sức khỏe, thai kỳ và chăm
          sóc trẻ dựa trên cài đặt của bạn
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>
        2. Thông tin sức khỏe được thu thập
      </PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[Chuẩn bị mang thai]</strong>
          <br />
          Thời gian và chu kỳ kinh nguyệt, ngày đầu kỳ kinh gần nhất, ngày bắt
          đầu và kết thúc kỳ kinh, ngày rụng trứng, ngày giờ, hình ảnh và kết
          quả que thử rụng trứng, ngày giờ, hình ảnh và kết quả que thử thai,
          nhiệt độ cơ thể cơ bản, triệu chứng, thông tin về đau và ra máu, quan
          hệ tình dục, sử dụng thuốc, tiêm chủng, khám bệnh và các thông tin sức
          khỏe khác do bạn ghi lại
        </li>
        <li>
          <strong>[Điều trị hiếm muộn]</strong>
          <br />
          Phương pháp điều trị hiếm muộn, chu kỳ điều trị, ngày bắt đầu và kết
          thúc điều trị, thông tin về thuốc và tiêm, lịch trình và nội dung điều
          trị
        </li>
        <li>
          <strong>[Thai kỳ]</strong>
          <br />
          Ngày dự sinh, tuổi thai, thông tin khám thai, tiêm chủng, cân nặng,
          hình ảnh siêu âm, các chỉ số thai nhi (EFW/AC/FL/BPD/HC/CRL), chiều
          cao và cân nặng trước khi mang thai và các thông tin khác liên quan
          đến thai kỳ do bạn ghi lại
        </li>
        <li>
          <strong>[Chăm sóc trẻ]</strong>
          <br />
          Ngày sinh của trẻ, chiều cao, cân nặng và vòng đầu khi sinh, thông tin
          tăng trưởng, kết quả và điểm đánh giá phát triển, hình ảnh liên quan
          đến sự phát triển, thông tin sinh non, khám sức khỏe, tiêm chủng, thân
          nhiệt, sử dụng thuốc và thông tin bệnh lý
        </li>
      </PolicyList>

      <PolicySectionTitle>3. Thời gian lưu giữ và sử dụng</PolicySectionTitle>
      <PolicyText>
        Khi bạn xóa một bản ghi đã lưu, thông tin liên quan đến bản ghi đó cũng
        sẽ được xóa. Khi bạn xóa tài khoản, dữ liệu cá nhân có thể nhận dạng bạn
        sẽ được xóa. Tuy nhiên, một số dữ liệu được tạo ra trong quá trình sử
        dụng Dịch vụ có thể được lưu giữ vô thời hạn cho mục đích nghiên cứu,
        phân tích thống kê và cải thiện dịch vụ sau khi được ẩn danh không thể
        đảo ngược để không thể nhận dạng lại bạn. Dữ liệu đã được ẩn danh không
        thể được liên kết lại với tài khoản hoặc dữ liệu cá nhân của bạn.
      </PolicyText>

      <PolicySectionTitle>Quyền từ chối đồng ý</PolicySectionTitle>
      <PolicyText>
        Việc đồng ý là tùy chọn. Bạn vẫn có thể tạo tài khoản pregnancy&baby và
        sử dụng các tính năng không yêu cầu xử lý thông tin sức khỏe nếu không
        đồng ý. Tuy nhiên, nếu không đồng ý, bạn có thể không sử dụng được các
        tính năng cần xử lý thông tin sức khỏe, bao gồm ghi chép về chuẩn bị
        mang thai, điều trị hiếm muộn, thai kỳ và chăm sóc trẻ.
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthVi;
